module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    class: [{
      'weui-bar__item_on': _vm.value === _vm.$parent.tabIndex && !_vm.disabled
    }, 'weui-tabbar__item vw-nav-item'],
    attrs: {
      "href": "javascript:;",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.select
    }
  }, [_c('span', {
    staticClass: "vw-nav-item-content"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "weui-tabbar__icon"
  }, [_c('i', {
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.img) ? _c('img', {
    staticClass: "weui-tabbar__icon",
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('vw-badge', {
    attrs: {
      "value": _vm.infoNum,
      "dot": _vm.dot
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-tabbar__label"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-10eecdde!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/nav-item.vue
// module id = 221
// module chunks = 0